import React from "react";
import {
  Box,
  Card,
  CardContent,
  Stack,
  Typography,
} from "@mui/material";

const LessonLocation = ({ location }) => {
  if (!location) return null;

  return (
    <Card elevation={0} sx={{ backgroundColor: '#f5f5f5', borderRadius: 2 }}>
      <CardContent sx={{ py: 1.5, '&:last-child': { pb: 1.5 } }}>
        <Stack direction="row" spacing={1.5} alignItems="center">
          <Box sx={{ fontSize: '1.25rem' }}>📍</Box>
          <Box>
            <Typography variant="body2" fontWeight="500">
              {location.name || 'Lokalizacja'}
            </Typography>
            {location.address && (
              <Typography variant="caption" color="text.secondary">
                {location.address}
              </Typography>
            )}
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default LessonLocation;
